import React from "react"

const Blinker: React.FC = () => {
  return (
    <div className="blinker absolute -top-2 right-[-14px] grid h-6 w-6">
      <span className="z-[2] col-start-1 row-start-1 m-auto h-2 w-2 rounded bg-primary"></span>
      <span className="z-[1] col-start-1 row-start-1 h-6 w-6 animate-blink rounded-xl bg-primary-dark"></span>
    </div>
  )
}

export default Blinker
